import { Button, Grid, makeStyles } from "@material-ui/core";
import { SelectField } from "components";
import { useForm } from "react-hook-form";
import { endpoints } from "appConfigs";
import { FormattedMessage } from "react-intl";

const useStyles = makeStyles((theme) => ({
  btns: {
    margin: "0 auto",
    marginRight: "0",
    marginBottom: "1rem",
    display: "flex",
    gridGap: "1rem",
    justifyContent: "flex-end",
  },
}));

const Form = ({ filters, setFilters }) => {
  const s = useStyles();
  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm();
  return (
    <Grid item className="mb-1">
      <form
        autoComplete={"off"}
        onSubmit={handleSubmit(async (values) => {
          const query = {};
          Object.entries(values).forEach(([key, value]) => {
            if (value) {
              query[key] = value;
            }
          });
          setFilters(query);
        })}
      >
        <Grid container spacing={3}>
          <Grid item sm={5}>
            <SelectField
              label={
                <FormattedMessage
                  id="healthGroups"
                  defaultMessage="Health Groups"
                />
              }
              name="health_group_id"
              control={control}
              multiple
              url={endpoints.healthGroups}
              getQuery={(inputValue, selected) => ({
                ...(inputValue && { name: inputValue }),
                ...(selected && { id: selected }),
              })}
              handleData={(data) => ({
                label: data.name,
                value: data.id,
              })}
            />
          </Grid>

          <Grid item sm={5}>
            <SelectField
              label={<FormattedMessage id="status" defaultMessage="Status" />}
              name="status"
              control={control}
              options={[
                { label: "Upcoming", value: "upcoming" },
                { label: "On Going", value: "ongoing" },
                { label: "Completed", value: "completed" },
                { label: "Expired", value: "expired" },
                { label: "Canceled by Doctor", value: "canceled_by_doctor" },
                { label: "Canceled by Admin", value: "canceled_by_admin" },
              ]}
            />
          </Grid>

          <Grid item sm={2} className={s.btns}>
            <Button type="submit" variant="contained" color="primary">
              <FormattedMessage id="search" defaultMessage="Search" />
            </Button>
            <Button
              type="button"
              variant="contained"
              onClick={() => {
                setFilters({});
                reset();
              }}
            >
              <FormattedMessage id="clear" defaultMessage="Clear" />
            </Button>
          </Grid>
        </Grid>
      </form>
    </Grid>
  );
};

export default Form;
